<div class="device-type-selector" [class.disabled]="disabled()">
  @if (showAllOption()) {
    <button
      type="button"
      class="device-type-selector__card"
      [class.selected]="allSelected()"
      role="checkbox"
      [attr.aria-checked]="allSelected()"
      [disabled]="disabled()"
      (click)="selectAll()">
      <span class="device-type-selector__marker">
        @if (allSelected()) {
          <span class="device-type-selector__check"></span>
        }
      </span>

      <span class="device-type-selector__icon">
        <app-device-type-icon [typeId]="allTypeId" />
      </span>

      <span class="device-type-selector__label">{{ allLabel() }}</span>
    </button>
  }

  @for (item of items(); track item.id) {
    <button
      type="button"
      class="device-type-selector__card"
      [class.selected]="isSelected(item)"
      [attr.role]="isMulti() ? 'checkbox' : 'radio'"
      [attr.aria-checked]="isSelected(item)"
      [disabled]="disabled()"
      (click)="selectItem(item)">
      <span class="device-type-selector__marker">
        @if (isSelected(item)) {
          <span class="device-type-selector__check"></span>
        }
      </span>

      <span class="device-type-selector__icon">
        <app-device-type-icon [typeId]="item.id" />
      </span>

      <span class="device-type-selector__label">{{ item.name }}</span>
    </button>
  }
</div>
